import type { ParlayLabelColor } from '@parlay-picker/shared/scoreDisplay';
import type React from 'react';

/**
 * Score bar visualization using the normalized 0-100 display score.
 */
export function ScoreBar({
  displayScore,
  displayColor,
}: {
  displayScore: number;
  displayColor: ParlayLabelColor;
}): React.ReactElement {
  const barColor =
    displayColor === 'success'
      ? 'bg-theme-success'
      : displayColor === 'lean'
        ? 'bg-teal-400'
        : displayColor === 'danger'
          ? 'bg-theme-danger'
          : displayColor === 'none'
            ? 'bg-slate-400'
            : 'bg-theme-warning';

  return (
    <div className="w-full h-2 bg-theme-surface rounded-full overflow-hidden">
      <div
        className={`h-full rounded-full transition-all ${barColor}`}
        style={{ width: `${displayScore}%` }}
      />
    </div>
  );
}
